import type { NotificationActionType } from "@circle-react/types/Notification";
import { UserImage } from "@circle-react-shared/uikit/UserImage";
import { NotificationTypeIcon } from "../UserImageWithIcon/NotificationTypeIcon";

export interface TwoUserImagesWithIconProps {
  src?: string;
  name: string;
  action: NotificationActionType;
  secondSrc?: string;
  secondName: string;
}

export const TwoUserImagesWithIcon = ({
  src = "",
  name,
  action,
  secondSrc = "",
  secondName,
}: TwoUserImagesWithIconProps) => (
  <div className="relative mr-3 h-8 w-8 shrink-0">
    <div className="absolute left-0 top-0">
      <UserImage src={src} name={name} size="5" />
    </div>
    <div className="absolute bottom-0 right-0">
      <div className="border-tertiary relative inline-flex h-fit w-fit shrink-0 grow-0 overflow-hidden rounded-full border-2">
        <UserImage src={secondSrc} name={secondName} size="5" />
      </div>
    </div>
    <NotificationTypeIcon action={action} />
  </div>
);
